module.exports = __webpack_public_path__ + "static/media/Guitar-3.5c7f430f.jpg";